<template>
  <page-wrapper sticky-second-row>
    <template #title>
      <div class="h3">Поддержка</div>
    </template>
    <div class="paragraph-m pb-4">Вы можете обратиться в Поддержку самостоятельно:</div>
    <div class="feedback__supports">
      <template v-for="(el, index) in supports" :key="index">
        <divider v-if="index !== 0 && $vuetify.display.mdAndUp" vertical class="mr-6 ml-6" height="40px" />
        <div class="d-flex pt-2 pb-2 pr-6 pr-sm-0">
          <div class="pr-3">
            <v-img :src="el.icon" width="40" />
          </div>
          <div class="paragraph-m_h">
            <p>{{ el.text }}</p>
            <a :href="el.href" class="text-link font-600">
              {{ el.value }}
            </a>
          </div>
        </div>
      </template>
    </div>
    <div class="paragraph-m pb-6">Либо воспользоваться формой обратной связи</div>
    <tabs-list :tabs="tabs">
      <template v-slot:[`tab.feedback`]>
        <feedback />
      </template>
    </tabs-list>
  </page-wrapper>
</template>

<script lang="ts" setup>
import iconEmail from '@/assets/img/pages/support/email.svg';
import iconPhone from '@/assets/img/pages/support/phone.svg';
// import iconTelegram from '@/assets/img/pages/support/telegram.svg';
import Divider from '@/core/components/helpers/Divider.vue';
import PageWrapper from '@/core/components/interface/PageWrapper.vue';
import TabsList from '@/core/components/interface/Tabs.vue';
import Feedback from '@/parts/support/components/Feedback.vue';

const supports = [
  {
    icon: iconEmail,
    text: 'Написав обращение на почту:',
    href: 'mailto:extranet@alean.ru',
    value: 'extranet@alean.ru',
  },
  {
    icon: iconPhone,
    text: 'Позвонив по телефону: ',
    href: 'tel:+74956466500',
    value: '+7(495) 646 65 00',
  },
  /* {
    icon: iconTelegram,
    text: 'Полезное в нашем канале: ',
    href: 'https://t.me/extranet_alean',
    value: '@extranet_alean',
  }, */
];

const tabs = [
  {
    title: 'Форма обратной связи',
    key: 'feedback',
  },
];
</script>

<style lang="scss" scoped>
.feedback {
  &__supports {
    display: flex;
    flex-wrap: wrap;
    align-items: center;

    padding-bottom: 24px;

    @include sm-and-down {
      flex-direction: column;
      align-items: flex-start;
    }
  }
}
</style>
